var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-image__preview"},[(_vm.showView)?_c('el-image-viewer',{attrs:{"on-close":_vm.closeViewer,"url-list":_vm.srcList}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }